import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import SignUpLayout from './index'

const SignUpLayoutRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <SignUpLayout>
        <Component {...props} />
      </SignUpLayout>
    )}
  />
)

SignUpLayoutRoute.propTypes = {
  component: PropTypes.func.isRequired
}

export default SignUpLayoutRoute
